module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail clearfix",
    staticStyle: {
      "padding-bottom": "24px"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.obj), function(item, index) {
    return (_vm.type == 1) ? _c('div', [_c('div', {
      staticClass: "qa-item"
    }, [_c('p', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        icon2: item.isopened
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isopened),
        expression: "item.isopened"
      }],
      staticClass: "qa-content"
    }, [_vm._v("\n            " + _vm._s(item.anwser) + "\n        ")]), _vm._v(" "), (index != 4 && !item.isopened) ? _c('div', {
      staticClass: "qa-line"
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.obj2), function(item, index) {
    return (_vm.type == 2) ? _c('div', [_c('div', {
      staticClass: "qa-item"
    }, [_c('p', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        icon2: item.isopened
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isopened),
        expression: "item.isopened"
      }],
      staticClass: "qa-content"
    }, [_vm._v("\n            " + _vm._s(item.anwser) + "\n        ")]), _vm._v(" "), (index != 2 && !item.isopened) ? _c('div', {
      staticClass: "qa-line"
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.obj3), function(item, index) {
    return (_vm.type == 3) ? _c('div', [_c('div', {
      staticClass: "qa-item"
    }, [_c('p', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        icon2: item.isopened
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isopened),
        expression: "item.isopened"
      }],
      staticClass: "qa-content"
    }, [_vm._v("\n            " + _vm._s(item.anwser) + "\n        ")]), _vm._v(" "), (index != 1 && !item.isopened) ? _c('div', {
      staticClass: "qa-line"
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.type == 4) ? _vm._l((_vm.obj4), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "qa-item"
    }, [_c('p', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        icon2: item.isopened
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isopened),
        expression: "item.isopened"
      }],
      staticClass: "qa-content"
    }, [_c('span', [_vm._v(_vm._s(item.anwser))]), _c('span', {
      staticStyle: {
        "color": "#0285f0"
      },
      on: {
        "click": function($event) {
          return _vm.handle(item)
        }
      }
    }, [_vm._v(_vm._s(item.event))])]), _vm._v(" "), (index != 1 && !item.isopened) ? _c('div', {
      staticClass: "qa-line"
    }) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), (_vm.type == 5) ? _vm._l((_vm.obj5), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "qa-item"
    }, [_c('p', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        icon2: item.isopened
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isopened),
        expression: "item.isopened"
      }],
      staticClass: "qa-content"
    }, [_vm._v("\n            " + _vm._s(item.anwser) + "\n        ")]), _vm._v(" "), (index != 1 && !item.isopened) ? _c('div', {
      staticClass: "qa-line"
    }) : _vm._e()])
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protect"
  }, [_c('p', [_vm._v("常见问题")]), _vm._v(" "), _c('div', {
    staticClass: "line left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28e2d350"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/qa.vue
// module id = 815
// module chunks = 1